// cSpell:ignore flexbox, STYuanti, vertical

import React from 'react';
import styled from 'styled-components';

import { Flex } from './static/style';

export default class ProgressBar extends React.Component {
    render() {
        const { data, style } = this.props;

        const barArr = initBar(data);

        return (
            <BarBox style={style} length={data && data.length ? data.length : 0}>
                <Progress>
                    {barArr && Array.isArray(barArr) && barArr.map((value, index) =>
                        value && value.type && value.type === 'line' ?
                            <CircleALine key={index} prevCircleStatus={barArr[index - 1 < 0 ? 0 : index - 1].status} />
                            : <Circle key={index} index={index} currentStatus={value.status} prevStatus={barArr[index - 2 < 0 ? 0 : index - 2].status} />)
                    }
                </Progress>
                <BarText>
                    {data && Array.isArray(data) && data.map((value, index) => <div key={index}>{value.text}</div>)}
                </BarText>
            </BarBox>
        );
    }
}

const initBar = (barData) => {
    const barArr = [];

    // 把横线填进去，好遍历（除了最后一个状态外，其他的状态都有横线链接）
    for (let i = 0; i < barData.length; i++) {
        barArr.push(barData[i]);

        if (i < barData.length - 1) {
            barArr.push({ type: 'line' });
        }
    }

    return barArr;
}

const BarBox = styled.div`
    font-size: 0.22rem;
    color: #646464;
    z-index: 1;
    font-weight:400;
    width: ${props => props.length > 2 ? '100%' : '70%'};
    margin: 0 auto;

    ${props => props.style ? props.style : ''}
`;

const Progress = styled(Flex)`
    height: 0.26rem;
    justify-content: space-between;
`;

const Circle = styled.div`
    width: 0.26rem;
    height: 0.26rem;
    border-radius: 50%;
    flex: none;
    background: #CBCAD6 url(${props => props.currentStatus > 0 ? require('./static/img/right-green.png') : ((props.prevStatus > 0 || props.index === 0) ? require('./static/img/right.png') : 'none')}) no-repeat center;
    background-size: contain;
`;

const CircleALine = styled.div`
    flex: 1;
    height: 0.04rem;
    margin-top: 0.1rem;
    background: ${props => props.prevCircleStatus > 0 ? '#00BD66' : '#CBCAD6'} ;
`;

const BarText = styled(Flex)`
    justify-content: space-between;
    margin-top: 0.1rem;
    text-align: center;

    >div {
        flex: 1;
    }

    >div:nth-child(1) {
        text-align: left;
    }

    >div:nth-child-last(1) {
        text-align: right;
    }
`;


// WEBPACK FOOTER //
// ./src/lib/components/LessonPath/lesson-progress-bar.js